import { BoardLayout } from "~/config/andonBoardLayouts/andonLayout.types";

const layouts: BoardLayout[] = [
  {
    name: "UNY4 - QA Ambient",
    dimensions: { columns: 5, rows: 4 },
    layout: [
      {
        w: 1,
        h: 1,
        x: 0,
        y: 0,
        i: "d6e3a573-fe6e-4664-b602-829962b85e87",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 1,
        y: 0,
        i: "147408a3-9288-4e09-85d8-11d495a2e91c",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 0,
        i: "614c17a5-b857-4c53-aafc-c6db81330abb",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 3,
        y: 0,
        i: "45c6d659-372b-4830-a729-ea07914e2181",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 0,
        i: "43faa114-0105-4194-b3ef-8cbd61a8c5b8",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 1,
        i: "7e989077-2a6a-4cf4-9f42-dc59c056b5dc",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 1,
        y: 1,
        i: "e0e2c513-9dd5-4551-a7a8-4b678da996d1",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 1,
        i: "24448279-8a25-4daa-8796-290f83323012",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 3,
        y: 1,
        i: "4ce518b5-f7b0-4989-a3ff-1b305838d480",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 1,
        i: "20a05cb1-176d-49db-8f58-5afa00a5b347",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 2,
        i: "87d2d9be-83c1-4c14-a09e-218e63b9ed81",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 1,
        y: 2,
        i: "b38633f4-67a9-4d8b-9c3b-74eeaa35cbc6",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 2,
        i: "0ee9c23c-98e9-4012-8bb7-3a701b54475c",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 3,
        y: 2,
        i: "77f08c80-0b3d-4ca4-904a-bca5c8c7d91e",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 2,
        i: "702c50d7-c441-4f0d-a98a-2b3e283a2700",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 3,
        i: "43990003-751e-41dc-b7f1-42d8fe26ceda",
        maxH: 1,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 1,
        y: 3,
        i: "b06205b8-6b29-4ac5-bad3-cfb6b78233a8",
        maxH: 1,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 3,
        i: "af5520cb-9fce-47b5-95ec-5ee7c8f933e4",
        maxH: 1,
        moved: false,
        static: false
      }
    ]
  },
  {
    name: "UNY4 - QA Chilled",
    dimensions: { columns: 5, rows: 4 },
    layout: [
      {
        w: 1,
        h: 1,
        x: 0,
        y: 0,
        i: "924ab68b-dcb1-4e33-9396-d54b435d2120",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 1,
        y: 0,
        i: "866c51cf-3158-4b60-b2bd-eece1adebe04",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 0,
        i: "4c3c4df4-b1a7-4814-8fff-315b5fb674ac",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 3,
        y: 0,
        i: "a727eb98-8eda-4a31-8033-8263a5d99742",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 0,
        i: "e67f2ca0-e91f-4660-8ac7-f38e3b4b64ad",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 1,
        i: "fed5e94b-fd82-4d5d-b22f-69a0286c7ac9",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 1,
        y: 1,
        i: "38d40272-5b64-4d5f-af6f-f1bba11b422f",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 1,
        i: "937ffe39-44fb-4b89-8daf-75abba984a1e",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 3,
        y: 1,
        i: "e9f0ae73-8a4e-47f3-b5fe-0fb6ed2e1245",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 1,
        i: "83533525-a7a0-4dbc-83ac-51e2648f6dbc",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 2,
        i: "577eb444-e355-4cec-bb11-02549443210f",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 1,
        y: 2,
        i: "0df13fa9-4430-4a72-88ef-f13f9d97fd30",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 2,
        i: "7b6135f8-8e07-4dfd-ac35-552f062986cd",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 3,
        y: 2,
        i: "b12249aa-3fe6-4199-8375-b52bc857bf36",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 2,
        i: "3236bd4c-99cb-4682-97db-5c26a67bb5b3",
        maxH: 2,
        moved: false,
        static: false
      }
    ]
  },
  {
    name: "UNY4 - Fulfillment Center",
    dimensions: { columns: 9, rows: 9 },
    layout: [
      {
        w: 1,
        h: 1,
        x: 1,
        y: 0,
        i: "d6e3a573-fe6e-4664-b602-829962b85e87",
        maxH: 9,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 5,
        i: "147408a3-9288-4e09-85d8-11d495a2e91c",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 6,
        i: "614c17a5-b857-4c53-aafc-c6db81330abb",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 7,
        i: "45c6d659-372b-4830-a729-ea07914e2181",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 4,
        i: "43faa114-0105-4194-b3ef-8cbd61a8c5b8",
        maxH: 5,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 5,
        i: "7e989077-2a6a-4cf4-9f42-dc59c056b5dc",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 6,
        i: "e0e2c513-9dd5-4551-a7a8-4b678da996d1",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 7,
        i: "24448279-8a25-4daa-8796-290f83323012",
        maxH: 2,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 8,
        i: "4ce518b5-f7b0-4989-a3ff-1b305838d480",
        maxH: 1,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 3,
        i: "20a05cb1-176d-49db-8f58-5afa00a5b347",
        maxH: 6,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 0,
        i: "87d2d9be-83c1-4c14-a09e-218e63b9ed81",
        maxH: 9,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 1,
        i: "b38633f4-67a9-4d8b-9c3b-74eeaa35cbc6",
        maxH: 8,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 2,
        i: "0ee9c23c-98e9-4012-8bb7-3a701b54475c",
        maxH: 7,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 3,
        i: "77f08c80-0b3d-4ca4-904a-bca5c8c7d91e",
        maxH: 6,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 0,
        y: 4,
        i: "702c50d7-c441-4f0d-a98a-2b3e283a2700",
        maxH: 5,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 0,
        i: "43990003-751e-41dc-b7f1-42d8fe26ceda",
        maxH: 9,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 1,
        i: "b06205b8-6b29-4ac5-bad3-cfb6b78233a8",
        maxH: 8,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 2,
        y: 2,
        i: "af5520cb-9fce-47b5-95ec-5ee7c8f933e4",
        maxH: 7,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 5,
        y: 0,
        i: "924ab68b-dcb1-4e33-9396-d54b435d2120",
        maxH: 9,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 3,
        i: "866c51cf-3158-4b60-b2bd-eece1adebe04",
        maxH: 6,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 4,
        i: "4c3c4df4-b1a7-4814-8fff-315b5fb674ac",
        maxH: 5,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 5,
        i: "a727eb98-8eda-4a31-8033-8263a5d99742",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 6,
        i: "e67f2ca0-e91f-4660-8ac7-f38e3b4b64ad",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 6,
        y: 4,
        i: "fed5e94b-fd82-4d5d-b22f-69a0286c7ac9",
        maxH: 5,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 6,
        y: 5,
        i: "38d40272-5b64-4d5f-af6f-f1bba11b422f",
        maxH: 4,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 6,
        y: 6,
        i: "937ffe39-44fb-4b89-8daf-75abba984a1e",
        maxH: 3,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 0,
        i: "e9f0ae73-8a4e-47f3-b5fe-0fb6ed2e1245",
        maxH: 9,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 1,
        i: "83533525-a7a0-4dbc-83ac-51e2648f6dbc",
        maxH: 8,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 4,
        y: 2,
        i: "577eb444-e355-4cec-bb11-02549443210f",
        maxH: 7,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 6,
        y: 0,
        i: "0df13fa9-4430-4a72-88ef-f13f9d97fd30",
        maxH: 9,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 6,
        y: 1,
        i: "7b6135f8-8e07-4dfd-ac35-552f062986cd",
        maxH: 8,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 6,
        y: 2,
        i: "b12249aa-3fe6-4199-8375-b52bc857bf36",
        maxH: 7,
        moved: false,
        static: false
      },
      {
        w: 1,
        h: 1,
        x: 6,
        y: 3,
        i: "3236bd4c-99cb-4682-97db-5c26a67bb5b3",
        maxH: 6,
        moved: false,
        static: false
      }
    ]
  }
];

export default layouts;
